import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import { CartProvider } from "./context/CartContext";
import SmoothScroll from "./components/SmoothScroll";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import AreaPage from "./pages/AreaPage";
import Consulting from "./pages/Consulting";
import Wine from "./pages/Wine";
import Library from "./pages/Library";
import Article from "./pages/Article";
import ZwischenraumSeries from "./pages/ZwischenraumSeries";
import ZwischenraumBand from "./pages/ZwischenraumBand";
import ZwischenraumReader from "./pages/ZwischenraumReader";
import LiveProducts from "./pages/LiveProducts";
import Shop from "./pages/Shop";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import CookieConsent from "./components/CookieConsent";
import ConciergeWidget from "./components/ConciergeWidget";
import BoardApp from "./board/BoardApp";

const detectBaseLang = () => {
  const seg =
    typeof window !== "undefined"
      ? window.location.pathname.split("/").filter(Boolean)[0]
      : "";
  if (seg === "en") return { base: "/en", lang: "en" };
  if (seg === "fr") return { base: "/fr", lang: "fr" };
  return { base: "/", lang: "de" };
};

const PublicShell = () => (
  <SmoothScroll>
    <Navbar />
    <main>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/interior" element={<AreaPage />} />
        <Route path="/fashion" element={<AreaPage />} />
        <Route path="/real-estate" element={<AreaPage />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/wine" element={<Wine />} />
        <Route path="/library" element={<Library />} />
        <Route path="/library/zwischenraum" element={<ZwischenraumSeries />} />
        <Route path="/library/zwischenraum/:band/lesen" element={<ZwischenraumReader />} />
        <Route path="/library/zwischenraum/:band" element={<ZwischenraumBand />} />
        <Route path="/library/:slug" element={<Article />} />
        <Route path="/live-products" element={<LiveProducts />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/impressum" element={<Legal type="impressum" />} />
        <Route path="/datenschutz" element={<Legal type="privacy" />} />
        <Route path="/agb" element={<Legal type="terms" />} />
      </Routes>
    </main>
    <Footer />
    <CookieConsent />
    <ConciergeWidget />
  </SmoothScroll>
);

const AppShell = () => {
  const { pathname } = useLocation();
  if (pathname === "/board" || pathname.startsWith("/board/")) return <BoardApp />;
  return <PublicShell />;
};

function App() {
  const { base, lang } = detectBaseLang();
  return (
    <div className="App grain">
      <LanguageProvider initialLang={lang}>
        <CartProvider>
          <BrowserRouter basename={base}>
            <AppShell />
          </BrowserRouter>
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#121212",
                border: "1px solid rgba(212,175,55,0.3)",
                color: "#F8F5F0",
                borderRadius: "0px",
              },
            }}
          />
        </CartProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
